export const pincodeCoordinates = {
  "110001": { locality: "Connaught Place", city: "Delhi", latitude: 28.6315, longitude: 77.2167 },
  "110025": { locality: "Jamia Nagar", city: "Delhi", latitude: 28.5614, longitude: 77.2811 },
  "110027": { locality: "Rajouri Garden", city: "Delhi", latitude: 28.6425, longitude: 77.1209 },
  "110074": { locality: "Chhatarpur", city: "Delhi", latitude: 28.4937, longitude: 77.181 },
  "110076": { locality: "Sarita Vihar", city: "Delhi", latitude: 28.5315, longitude: 77.3023 },
  "110078": { locality: "Dwarka Sector 12", city: "Delhi", latitude: 28.5921, longitude: 77.046 },
  "110085": { locality: "Rohini Sector 10", city: "Delhi", latitude: 28.7213, longitude: 77.1238 },
  "110091": { locality: "Mayur Vihar Phase 1", city: "Delhi", latitude: 28.6044, longitude: 77.2951 },
  "122001": { locality: "Sector 29", city: "Gurgaon", latitude: 28.4675, longitude: 77.0726 },
  "201001": { locality: "Ghaziabad City", city: "Ghaziabad", latitude: 28.6692, longitude: 77.4538 },
  "201010": { locality: "Vaishali", city: "Ghaziabad", latitude: 28.6459, longitude: 77.3399 },
  "201011": { locality: "Pratap Vihar", city: "Ghaziabad", latitude: 28.6894, longitude: 77.4127 },
  "201012": { locality: "Vasundhara", city: "Ghaziabad", latitude: 28.6637, longitude: 77.3713 },
  "201014": { locality: "Indirapuram", city: "Ghaziabad", latitude: 28.6469, longitude: 77.3695 },
  "201018": { locality: "Noida Sector 62", city: "Noida", latitude: 28.6266, longitude: 77.3649 },
  "201301": { locality: "Noida Sector 18", city: "Noida", latitude: 28.5708, longitude: 77.326 },
  "201309": { locality: "Greater Noida West", city: "Noida", latitude: 28.6204, longitude: 77.4294 },
  "201310": { locality: "Pari Chowk", city: "Greater Noida", latitude: 28.4744, longitude: 77.503 },
  "201318": { locality: "Noida Extension", city: "Noida", latitude: 28.5874, longitude: 77.3905 },
  "121010": { locality: "Surajkund Road", city: "Faridabad", latitude: 28.4906, longitude: 77.2832 },
};

export const getPincodeCoordinates = (pincode) => pincodeCoordinates[pincode] ?? null;

export const mappedPincodes = Object.keys(pincodeCoordinates).sort();
